import React from 'react';
import styled from 'styled-components';
import { brandColors } from 'styles/colors';
import { pageToolbarHeight } from 'styles/spacings';

export const Button = styled(({ children, type = 'button', ...props }) => (
	<button type={type} {...props}>
		<ButtonText>{children}</ButtonText>
	</button>
))`
	flex: none;
	padding: 0 26px;
	height: ${pageToolbarHeight};
	text-transform: uppercase;
	background: transparent;
	border: 0;
	font-size: 13px;
	font-weight: bold;
	outline: none;
	color: ${brandColors.green};

	&:disabled {
		opacity: 0.4;
	}
`;

const ButtonText = styled.span`
	border-bottom: 2px solid transparent;
	transition: border 200ms ease-in-out;

	${Button}:not(:disabled):hover &,
	${Button}:not(:disabled):focus & {
		border-color: currentColor;
	}
`;
